<template>
  <v-card v-if="showCbteAsociado()" elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Comprobante asociado</h6>
      <p class="text-body-2">Seleccione el comprobante que desea asociar</p>

      <v-row>
        <v-col cols="12" md="8">
          <v-combobox
            :disabled="isViewModal || invoice_to_cancel != null || loading_spent || !invoice.supplier"
            v-model="selected_spent"
            data-vv-as="Comprobante"
            name="spent_to_associate"
            :item-text="spent_name"
            item-value="id"
            :items="spents_available"
            label="Seleccione un comprobante para asociar"
            autocomplete="off"
            :loading="loading_spent"
            clearable
            @change="onSpentSelected"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ !invoice.supplier ? "Primero seleccione un proveedor" : "No hay comprobantes disponibles para asociar" }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>
        </v-col>
      </v-row>

      <!-- Mostrar comprobante asociado si existe -->
      <v-row v-if="invoice.cbte_asoc && invoice.cbte_asoc.length > 0">
        <v-col cols="12">
          <v-chip 
            v-for="(cbte, index) in invoice.cbte_asoc" 
            :key="index"
            class="ma-2"
            color="primary"
            outlined
            :close="!isViewModal"
            @click:close="removeAssociation(index)"
            :close-disabled="isViewModal || invoice_to_cancel != null"
          >
            <v-icon left small>mdi-file-document</v-icon>
            {{ cbte.spent_number_label || cbte.voucher_number_label }} - {{ formatUtils.formatPrice(cbte.imp_total) }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { spentService } from "@/libs/ws/spentService";
import { vouchersService } from "@/libs/ws/vouchersService";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: {},
  props: {
    invoice: Object,
    invoice_to_cancel: Object,
    loading_combos: Object,
    comprobante_asociado: Object,
    loading_voucher_asociado: Boolean,
    error_search_cbte_asociado: Boolean,
    searchCbteAsociado: Function,
    validator: Object,
    isViewModal: { type: Boolean, default: false },
  },
  data: () => ({
    formatUtils: formatUtils,
    spents_available: [],
    selected_spent: null,
    loading_spent: false,
    supplier_selected: null,
  }),
  watch: {
    invoice: {
      handler: function (newValue) {
        if (newValue == null) {
          return;
        }
        
        // Cargar comprobantes pendientes cuando cambia el proveedor
        if ((this.supplier_selected == null && newValue.supplier != null) || 
            (newValue.supplier != null && this.supplier_selected != null && this.supplier_selected.id != newValue.supplier.id)) {
          this.supplier_selected = newValue.supplier;
          this.loadPendingSpents();
          
          // Limpiar selección si no viene de invoice_to_cancel
          if (this.invoice_to_cancel == null && (!this.invoice.cbte_asoc || this.invoice.cbte_asoc.length === 0)) {
            this.selected_spent = null;
            this.errors.clear();
            this.validator.reset();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // Cargar comprobantes pendientes si ya hay proveedor seleccionado
    if (this.invoice && this.invoice.supplier) {
      this.supplier_selected = this.invoice.supplier;
      this.loadPendingSpents();
    }
  },
  methods: {
    spent_name: (item) => (
      item.id != 0 
        ? formatUtils.formatDateString(item.cbte_fch) + " - " + item.spent_number_label + " - (" + formatUtils.formatPrice(item.imp_total) + ")" 
        : item.spent_number_label
    ),
    loadPendingSpents() {
      if (!this.invoice || !this.invoice.supplier) {
        this.spents_available = [];
        return;
      }

      this.loading_spent = true;
      const params = {
        supplier: this.invoice.supplier.id,
      };

      if (this.invoice.receiver && this.invoice.receiver.id > 0) {
        params.receiver_id = this.invoice.receiver.id;
      }

      spentService
        .getPendingSpents(params)
        .then((response) => {
          if (response.status) {
            // Filtrar los comprobantes que ya están asociados
            const associatedIds = (this.invoice.cbte_asoc || []).map((cbte) => cbte.id);
            this.spents_available = response.result.filter(
              (spent) => !associatedIds.includes(spent.id)
            );
          } else {
            this.spents_available = [];
          }
        })
        .catch((e) => {
          console.log("getPendingSpents error", e);
          this.spents_available = [];
        })
        .finally(() => {
          this.loading_spent = false;
        });
    },
    onSpentSelected() {
      if (!this.selected_spent || this.selected_spent.id == 0) {
        return;
      }

      // Agregar el comprobante seleccionado a invoice.cbte_asoc
      if (!this.invoice.cbte_asoc) {
        this.invoice.cbte_asoc = [];
      }

      // Verificar que no esté ya agregado
      const exists = this.invoice.cbte_asoc.find((cbte) => cbte.id === this.selected_spent.id);
      if (exists) {
        this.$toast.warning("El comprobante ya está asociado");
        this.selected_spent = null;
        return;
      }

      // Para notas de crédito/débito, solo permitir un comprobante asociado
      if (this.invoice.cbte_asoc.length > 0 && this.invoice.cbte_tipo && 
          (!vouchersService.VoucherList().includes(this.invoice.cbte_tipo.Id))) {
        this.$toast.warning("Solo se puede asociar un comprobante");
        this.selected_spent = null;
        return;
      }

      // Agregar el comprobante
      this.invoice.cbte_asoc.push(this.selected_spent);
      
      // Remover de la lista de disponibles
      const index = this.spents_available.findIndex((s) => s.id === this.selected_spent.id);
      if (index > -1) {
        this.spents_available.splice(index, 1);
      }

      this.$toast.success("Comprobante agregado correctamente");
      this.selected_spent = null;
    },
    removeAssociation(index) {
      if (this.isViewModal || this.invoice_to_cancel != null) {
        return;
      }

      const removedSpent = this.invoice.cbte_asoc[index];
      this.invoice.cbte_asoc.splice(index, 1);
      
      // Agregar de vuelta a la lista de disponibles
      if (removedSpent && removedSpent.id) {
        this.spents_available.push(removedSpent);
      }

      this.$toast.info("Comprobante desasociado");
    },
    showCbteAsociado() {
      if (this.invoice == null || (this.invoice != null && this.invoice.cbte_tipo == null)) {
        return false;
      }
      return !vouchersService.VoucherList().includes(this.invoice.cbte_tipo.Id);
    },
  },
};
</script>
